const BRAINTREE_VERSION = "3.144.0";
const BRAINTREE_BASE_URL = `https://js.braintreegateway.com/web/${BRAINTREE_VERSION}/js`;

const MODULES = ["client", "paypal-checkout", "data-collector"] as const;

const loaded: { [src: string]: Promise<void> } = {};

function loadScript(src: string): Promise<void> {
    if (loaded[src]) {
        return loaded[src];
    }

    const pending = new Promise<void>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            // Drop the failed tag so retries do not accumulate dead <script> elements, and evict
            // the cache entry so a later attempt can try again. The identity check makes sure we
            // only evict our own entry - a newer attempt may already have replaced it.
            script.remove();
            if (loaded[src] === pending) {
                delete loaded[src];
            }
            reject(new Error(`Failed to load ${src}`));
        };
        document.head.appendChild(script);
    });

    loaded[src] = pending;
    return pending;
}

/**
 * Loads the Braintree client SDK on demand so merchants only import shift4.js.
 * Scripts are fetched once per page and only for merchants that actually use PayPal.
 */
export function loadBraintreeSdk(): Promise<any> {
    return Promise.all(MODULES.map(module => loadScript(`${BRAINTREE_BASE_URL}/${module}.min.js`)))
        .then(() => {
            const braintree = (window as any).braintree;
            if (!braintree) {
                throw new Error("Braintree SDK loaded but window.braintree is not defined");
            }
            return braintree;
        });
}
